// function isUndefined (query) {
//   return typeof query === 'undefined'
// }

function dig (ob, path, defaultValue) {
  let def = typeof defaultValue !== 'undefined' ? defaultValue : false
  if (!ob || typeof ob === 'undefined') {
    return def
  }
  let part = path.shift()
  if (path.length > 0) {
    if (typeof ob[part] !== 'undefined') {
      return dig(ob[part], path, def)
    } else {
      return def
    }
  } else if (typeof ob[part] !== 'undefined') {
    return ob[part]
  } else {
    return def
  }
}

function getPropertyByPath (obj, path, defaultValue) {
  return dig(obj, path.split('.'), defaultValue)
}

export default {
  computed: {
    tag () {
      return `items.${this.$options._componentTag}-${this.content.key}`
    }
  },
  methods: {
    $path (defaultText, replacement, page) {
      let translations = this.$store.state.translations
      if (typeof translations === 'undefined') {
        return defaultText
      }
      let language = this.$store.state.language
      let key = `${page}.${replacement}.${language}`
      return key
    },
    $t (defaultText, replacement, page) {
      let translations = this.$store.state.translations
      if (typeof translations === 'undefined') {
        return defaultText
      }
      let language = this.$store.state.language

      let translation
      let key = `${page}.${replacement}.${language}`
      translation = getPropertyByPath(translations, key, null)
      if (!translation) {
        if (this.$store.getters.multilingual) {
          console.log(`Missing text ${defaultText}. Looked here: ${key}`)
        }
        translation = defaultText
      }
      return translation
    }
  }
}
